import Service from './Service';

export default class ServiceCategoryService extends Service{
    constructor() {
        super();
        this.baseURL = 'serviceCategory';
    }

}